import { Environment, isValidEnv } from './utils';

/**
 * Attempts to determine the environment to use for the GraphQL server using
 * the application's environment.
 * 
 * @returns { string }
 */
export function getGraphqlEnv( appEnv ) {
    // return Environment.LOCAL;
    return isValidEnv( appEnv ) ? appEnv : Environment.LOCAL;
}
